import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import { imageUrl } from "../actions/miscAction";

const leftArrowIcon = imageUrl("leftArrowIcon");

class PipeFilterSidebarMobile extends Component {
  state = {
    tab: 1,
    od: "",
    wt: "",
    weight: "",
    unitMeasure: 0,
    length: "",
    nrofPipes: "",
    totalLength: "",
    averageJoin: "",
    totalWeight: "",
    scrap: "",
    totalScrap: "",
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
      const script = document.createElement("script");
      script.src =
        "https://www.barchart.com/widget.js?uid=7c97d40cc2f911361b1bb3050a800ab4&widgetType=chart&showChart=true&widgetWidth=214&chartType=AREA&chartColor[area]=46ad1d&fontColor[links]=46ad1d&font=1&animated=1&symbols[]=xom&fields[]=name&fields[]=last&fields[]=change&displayChars";
      script.async = true;
      document.body.appendChild(script);
    }
  };

  showMore = (counts, data, type) => {
    this.props.filterModalDataCounts(counts);
    this.props.filterModalData(data);
    this.props.toggleFilter();
    this.props.modalType(type);
  };

  calculateScrap = () => {
    const length = this.state.length;
    const nrofPipes = this.state.nrofPipes;
    const weight = this.state.weight;
    var scrapprice = this.state.scrap;

    const constant = this.state.unitMeasure ? 1000 : 2204.6;

    if (!scrapprice) {
      scrapprice = 200;
    } else {
      scrapprice = parseFloat(this.state.scrap);
    }

    try {
      // H= B*E*F/ 2204.6
      var result = ((scrapprice * weight * length * nrofPipes) / constant).toFixed(2);
      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ totalScrap: result });
  };

  calculateTotalWeight = () => {
    const length = this.state.length;
    const nrofPipes = this.state.nrofPipes;
    const weight = this.state.weight;
    const totalLength = this.state.totalLength;

    const constant = this.state.unitMeasure ? 1000 : 2204.6;

    try {
      // H= B*E*F/ 2204.6
      if (totalLength) {
        var result = ((weight * totalLength) / constant).toFixed(2);
      } else {
        result = ((weight * length * nrofPipes) / constant).toFixed(2);
      }

      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ totalWeight: result });
  };

  calctotalJoin = () => {
    const totalLength = parseFloat(this.state.totalLength);
    const nrofPipes = parseFloat(this.state.nrofPipes);
    var result = "";

    try {
      result = (totalLength / nrofPipes).toFixed(2);
      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ averageJoin: result });
  };

  calctotalLength = () => {
    const length = parseFloat(this.state.length);
    const nrofPipes = parseFloat(this.state.nrofPipes);
    var result = "";

    try {
      result = (length * nrofPipes).toFixed(2);
      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ totalLength: result });
  };

  toDecimal(_x) {
    var parts = _x.split(" ");

    if (parts.length > 2 || isNaN(parts[0])) {
      alert("Outer Diameter must be entered as a fraction.");
      return 0;
    }

    // if no second element, then must be a whole number
    if (!parts[1]) {
      return _x;
    }

    var decParts = parts[1].split("/");
    return parseInt(parts[0], 10) + parseInt(decParts[0], 10) / parseInt(decParts[1], 10);
  }

  calculateWeightOf = () => {
    const od = this.state.od;
    const wt = parseFloat(this.state.wt);
    const um = this.state.unitMeasure;

    const s = um ? od : this.toDecimal(od);

    const constant = um ? 0.0246421502959472 : 10.69;

    // wt provided
    if (wt) {
      try {
        // B=10.69*(A-C)*C
        var result = (constant * (s - wt) * wt).toFixed(3);
        result = result.replace(/^0\.*/, ".");
      } catch (err) {
        result = "";
      }
      result = isNaN(result) ? "" : result;

      this.setState({ weight: result });
    } else {
      alert("Wall Thickness is required for calculating weight");
    }
  };

  calculateWt = () => {
    const od = this.state.od;
    const weight = this.state.weight;

    const um = this.state.unitMeasure;

    const s = um ? od : this.toDecimal(od);
    const w = weight;

    const constant = um ? 0.0246421502959472 : 10.69;

    // weight provided
    if (weight) {
      try {
        var result = ((s - Math.sqrt(Math.pow(s, 2) - (4 / constant) * w)) / 2).toFixed(3);
        result = result.replace(/^0\.*/, ".");
      } catch (err) {
        result = "";
      }
      result = isNaN(result) ? "" : result;
      this.setState({ wt: result });
    } else {
      alert("Weight is required for calculating Wall thinkness");
    }
  };

  render() {
    const {
      catagory,
      catagory1,
      make,
      model,
      region,
      removeFilter,
      saleType,
      pipeType,
      pipeCondition,
      pipeMillCert,
      pipeSize,
      pipeMaterial,
    } = this.props;
    const { facets } = this.props;
    const sale_type = facets["pipe.sale_type"] && Object.keys(facets["pipe.sale_type"]);
    const pipe_type = facets["pipe.sale_type"] && Object.keys(facets["pipe.pipe_type"]);
    const pipe_condition = facets["pipe.pipe_condition"] && Object.keys(facets["pipe.pipe_condition"]);
    const pipe_mill_cert = facets["pipe.pipe_mill_cert"] && Object.keys(facets["pipe.pipe_mill_cert"]);

    const pipe_size = facets["pipe.pipe_size"] && Object.keys(facets["pipe.pipe_size"]);
    const pipe_material = facets["pipe.pipe_material"] && Object.keys(facets["pipe.pipe_material"]);
    const cat = _.take(facets["categories.lvl0"] && Object.keys(facets["categories.lvl0"]), 6);
    const subCat = _.take(facets["categories.lvl1"] && Object.keys(facets["categories.lvl1"]), 6);
    const makefilter = facets["make"] && Object.keys(facets["make"]);
    const modelfilter = _.take(facets["model"] && Object.keys(facets["model"]), 6);
    const regionfilter = facets["region"] && Object.keys(facets["region"]);

    const activeFilters = [...catagory, ...catagory1, ...make, ...model, ...region];
    const showFilters = _.take(activeFilters, this.state.filtersShow);
    const ModifiedPipeMilCart = [];
    if (pipeMillCert.length === 2) {
      pipeMillCert.find((v) => v === "No") ? ModifiedPipeMilCart.push("No") : ModifiedPipeMilCart.push("Yes");
    } else if (pipeMillCert.length === 4) {
      ModifiedPipeMilCart.push("No");
      ModifiedPipeMilCart.push("Yes");
    }
    return (
      <Modal
        className={"modal left-collapse fade"}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="filterCollapse"
        tabindex="-1"
        role="dialog"
        dialogClassName="modal-dialog"
      >
        <div class="filter-collapse-content">
          <div class="fcc-header d-flex align-items-center justify-content-between">
            <div class="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => this.props.toggleModal()}>
              <img src={leftArrowIcon} alt="leftArrowIcon" />
            </div>
            <h3 class="fcc-title" id="myModalLabel">
              Filter
            </h3>
            <small
              onClick={(e) => {
                e.preventDefault();
                this.props.clearFilter("all");
                this.props.toggleModal();
              }}
            >
              Clear filters
            </small>
          </div>
          <div class="fcc-body">
            <div class="fcc-tab-container d-flex">
              <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                {sale_type && sale_type.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 1 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 1 });
                    }}
                  >
                    Sale Type
                  </a>
                )}
                {pipe_size && pipe_size.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 6 && "active"}`}
                    id="v-pills-tab-F-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-F"
                    role="tab"
                    aria-controls="v-pills-tab-F"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 6 });
                    }}
                  >
                    Size
                  </a>
                )}
                {pipe_type && pipe_type.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 2 && "active"}`}
                    id="v-pills-tab-B-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-B"
                    role="tab"
                    aria-controls="v-pills-tab-B"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 2 });
                    }}
                  >
                    Pipe Type
                  </a>
                )}
                {pipe_condition && pipe_condition.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 3 && "active"}`}
                    id="v-pills-tab-C-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-C"
                    role="tab"
                    aria-controls="v-pills-tab-C"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 3 });
                    }}
                  >
                    Pipe Condition
                  </a>
                )}
                {pipe_mill_cert && pipe_mill_cert.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 4 && "active"}`}
                    id="v-pills-tab-D-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-D"
                    role="tab"
                    aria-controls="v-pills-tab-D"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 4 });
                    }}
                  >
                    Mill Test Reports
                  </a>
                )}
                {pipe_material && pipe_material.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 5 && "active"}`}
                    id="v-pills-tab-E-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-E"
                    role="tab"
                    aria-controls="v-pills-tab-E"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 5 });
                    }}
                  >
                    Pipe Material
                  </a>
                )}

                {makefilter && makefilter.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 7 && "active"}`}
                    id="v-pills-tab-G-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-G"
                    role="tab"
                    aria-controls="v-pills-tab-G"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 7 });
                    }}
                  >
                    Manufacturer
                  </a>
                )}
                {regionfilter && regionfilter.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 8 && "active"}`}
                    id="v-pills-tab-H-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-H"
                    role="tab"
                    aria-controls="v-pills-tab-H"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 8 });
                    }}
                  >
                    Region
                  </a>
                )}
                <a
                  class={`nav-link ${this.state.tab === 9 && "active"}`}
                  id="v-pills-tab-J-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-pane-J"
                  role="tab"
                  aria-controls="v-pills-tab-J"
                  aria-selected="false"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ tab: 9 });
                  }}
                >
                  Pipe Calculator
                </a>
              </div>
              <div class="tab-content" id="v-pills-tabContent">
                <div
                  class={`tab-pane fade ${this.state.tab === 1 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {sale_type &&
                      sale_type.length > 0 &&
                      sale_type.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={saleType.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("saleType", v)}>
                            {v === "Wanted Pipe (Sell Pipe)"
                              ? "Operator Procurement Request "
                              : " Surplus Pipe For Sale "}{" "}
                            ({facets["pipe.sale_type"][v]})
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 6 && "show active"}`}
                  id="v-pills-pane-F"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {pipe_size &&
                      pipe_size.length > 0 &&
                      pipe_size.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={pipeSize.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeSize", v)}>
                            {`${v} (${facets["pipe.pipe_size"][v]})`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 2 && "show active"}`}
                  id="v-pills-pane-B"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {pipe_type &&
                      pipe_type.length > 0 &&
                      pipe_type.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={pipeType.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeType", v)}>
                            {`${v} (${facets["pipe.pipe_type"][v]})`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 3 && "show active"}`}
                  id="v-pills-pane-C"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {pipe_condition &&
                      pipe_condition.length > 0 &&
                      pipe_condition.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={pipeCondition.find((ev) => ev === v) ? true : false}
                          />
                          <label
                            class="form-check-label"
                            for={v}
                            onClick={() => this.props.setData("pipeCondition", v)}
                          >
                            {`${v} (${facets["pipe.pipe_condition"][v]})`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 4 && "show active"}`}
                  id="v-pills-pane-D"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {pipe_mill_cert &&
                      pipe_mill_cert.length > 0 &&
                      ["No", "Yes"].map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={pipeMillCert.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeMillCert", v)}>
                            {`${v} (${
                              v === "No"
                                ? facets["pipe.pipe_mill_cert"][v] + facets["pipe.pipe_mill_cert"]["false"]
                                : facets["pipe.pipe_mill_cert"][v] + facets["pipe.pipe_mill_cert"]["true"]
                            })`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 5 && "show active"}`}
                  id="v-pills-pane-E"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {pipe_material &&
                      pipe_material.length > 0 &&
                      pipe_material.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={pipeMaterial.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeMaterial", v)}>
                            {`${v} (${facets["pipe.pipe_material"][v]})`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>

                <div
                  class={`tab-pane fade ${this.state.tab === 7 && "show active"}`}
                  id="v-pills-pane-G"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {makefilter &&
                      makefilter.length > 0 &&
                      makefilter.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={make.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("make", v)}>
                            {`${v} (${facets["make"][v]})`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 8 && "show active"}`}
                  id="v-pills-pane-H"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {regionfilter &&
                      regionfilter.length > 0 &&
                      regionfilter.map((v) => (
                        <div class="form-check d-flex align-items-center">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={region.find((ev) => ev === v) ? true : false}
                          />
                          <label class="form-check-label" for={v} onClick={() => this.props.setData("region", v)}>
                            {`${v} (${facets["region"][v]})`}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>

                <div
                  class={`tab-pane fade ${this.state.tab === 9 && "show active"}`}
                  id="v-pills-pane-J"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    <a href="javascript:void(0)" class="calculate-link">
                      Calculate Pounds per Foot or Wall Thickness
                    </a>
                    <div class="form-group">
                      <label for="size" class="form-label">
                        Size of Outer Diameter
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="size"
                        value={this.state.od}
                        onChange={(e) => this.setState({ od: e.target.value })}
                      />
                    </div>
                    <div class="form-group">
                      <label for="" class="form-label">
                        Weight of Pipe
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Recipient's username"
                          aria-describedby="calculate"
                          value={this.state.weight}
                          onChange={(e) => this.setState({ weight: e.target.value })}
                        />
                        <span class="input-group-text" id="calculate" onClick={() => this.calculateWeightOf()}>
                          Calculate
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="" class="form-label">
                        Wall Thickness of Pipe
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Recipient's username"
                          aria-describedby="calculate"
                          value={this.state.wt}
                          onChange={(e) => this.setState({ wt: e.target.value })}
                        />
                        <span class="input-group-text" id="calculate" onClick={this.calculateWt}>
                          Calculate
                        </span>
                      </div>
                    </div>
                    <div class="partition"></div>
                    <a href="javascript:void(0)" class="calculate-link">
                      Calculate Total Length, Total Weight, and Estimated Scrap Price
                    </a>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="length" class="form-label">
                            Length of each Joint
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="length"
                            value={this.state.length}
                            onChange={(e) => this.setState({ length: e.target.value })}
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="totalNumber" class="form-label">
                            Total Number of Pipes
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="totalNumber"
                            value={this.state.nrofPipes}
                            onChange={(e) => this.setState({ nrofPipes: e.target.value })}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="calcluateTotal" class="form-label">
                        Calcluate Total Length
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Recipient's username"
                          aria-describedby="calcluateTotal"
                          value={this.state.totalLength}
                          onChange={(e) => this.setState({ totalLength: e.target.value })}
                        />
                        <span
                          class="input-group-text cursor-pointer"
                          id="calcluateTotal"
                          onClick={this.calctotalLength}
                        >
                          Calculate
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="calculateAverage" class="form-label">
                        Calcluate Average Joint Length
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Recipient's username"
                          aria-describedby="calculateAverage"
                          value={this.state.averageJoin}
                        />
                        <span class="input-group-text" id="calculateAverage" onClick={this.calctotalJoin}>
                          Calculate
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="calculateWeight" class="form-label">
                        Calcluate Total Weight
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Recipient's username"
                          aria-describedby="calculateWeight"
                          value={this.state.totalWeight}
                        />
                        <span
                          class="input-group-text cursor-pointer"
                          id="calculateWeight"
                          onClick={this.calculateTotalWeight}
                        >
                          Calculate
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="scrap" class="form-label">
                        Scrap
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="scrap"
                        value={this.state.scrap}
                        onChange={(e) => this.setState({ scrap: e.target.value })}
                      />
                    </div>
                    <div class="form-group">
                      <label for="scrapPrice" class="form-label">
                        Estimated Scrap Price
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Recipient's username"
                          aria-describedby="scrapPrice"
                          value={this.state.totalScrap}
                        />
                        <span class="input-group-text cursor-pointer" id="scrapPrice" onClick={this.calculateScrap}>
                          Calculate
                        </span>
                      </div>
                    </div>
                    <div class="partition"></div>
                    <div class="graph" id="xom">
                      <script
                        type="text/javascript"
                        src="https://www.barchart.com/widget.js?uid=7c97d40cc2f911361b1bb3050a800ab4&widgetType=chart&showChart=true&widgetWidth=214&chartType=AREA&chartColor[area]=46ad1d&fontColor[links]=46ad1d&font=1&animated=1&symbols[]=xom&fields[]=name&fields[]=last&fields[]=change&displayChars"
                      ></script>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default PipeFilterSidebarMobile;
